import {createSelector} from "reselect";
import {IOrpyxApplicationStore} from "../../../store/application.reducers";

export class RemotePatientMonitoringSigninSelectors {
    static readonly state = (state: IOrpyxApplicationStore) => state.remotePatientMonitoring;
    static readonly error = createSelector(RemotePatientMonitoringSigninSelectors.state, state => state.error);
}